<template>
    <el-dialog title="编辑会员资料" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
               :close-on-press-escape="false" width="800px">
        <el-form size="small" :model="form">

            <el-form-item label="头像：" prop="avatarUrl"  :label-width="formLabelWidth">
            <div class="draggable-list">
                <div v-if="form.avatarUrl">
                    <div class="item">
                        <img v-img-url="form.avatarUrl" alt="file_path"/>
                        </div>
                    </div>
                <div class="item img-select" @click="openProductUpload('avatarUrl')">
                <i class="el-icon-plus"></i>
                </div>
            </div>
            </el-form-item>

            <el-form-item label="客户姓名" :label-width="formLabelWidth">
                <el-input v-model="form.nickName" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="手机号" :label-width="formLabelWidth">
                <el-input v-model="form.mobile" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="email" :label-width="formLabelWidth">
              <el-input v-model="form.email" maxlength=11 placeholder="请输入邮箱"></el-input>
            </el-form-item>

            <el-form-item label="密码" :label-width="formLabelWidth">
                <el-input v-model="password_val" autocomplete="off" type="password" placeholder="不输入则不修改密码"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" :label-width="formLabelWidth">
                <el-input v-model="password_val2" autocomplete="off" type="password" placeholder="请确认新密码"></el-input>
            </el-form-item>

            <el-form-item label="角色"  :label-width="formLabelWidth">
                <el-select v-model="form.role" placeholder="请选择" @change="handleRoleChange">
                    <el-option v-for="(item, index) in rolearr" :key="index" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>

            <!-- 省经销商和市经销商专属字段 -->
            <template v-if="isDealerRole">
                <el-form-item label="年销售任务" :label-width="formLabelWidth">
                    <el-input 
                        v-model="form.saletask" 
                        type="number"
                        placeholder="请输入年销售任务（家）"
                        style="width: 200px">
                        <template slot="append">家</template>
                    </el-input>
                </el-form-item>
                
                <el-form-item label="推广数量" :label-width="formLabelWidth">
                    <el-input 
                        v-model="form.num" 
                        type="number"
                        placeholder="请输入推广数量"
                        style="width: 200px">
                        <template slot="append">个</template>
                    </el-input>
                </el-form-item>
            </template>

            <el-form-item label="等级" :label-width="formLabelWidth">
              <el-select v-model="form.grade_id" placeholder="-请选择等级-">
                <el-option v-for="(item,index) in gradeList" :key="index" :label="item.name" :value="item.grade_id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="折扣" :label-width="formLabelWidth">
                <template>
                    <div class="d-s-c">
                        <el-input v-model="form.buy_pdiscount" type="number" placeholder="请输入折扣">
                            <template slot="prepend">
                            购省级经销商折扣：
                            </template>
                            <template slot="append">
                            折
                            </template>
                        </el-input>
                    </div>
                    <div class="d-s-c" style="margin-top: 10px;">
                        <el-input v-model="form.buy_cdiscount" type="number" placeholder="请输入折扣">
                            <template slot="prepend">
                            购市级经销商折扣：
                            </template>
                            <template slot="append">
                            折
                            </template>
                        </el-input>
                    </div>
                </template>
            </el-form-item>
            <el-form-item label="所在区域" :label-width="formLabelWidth" >
              <div style="display: flex;">
                <el-select @change="provinceChange" v-model="form.province_name" filterable  placeholder="请选择省份">
                    <el-option
                            v-for="item in province_options"
                            :key="item.id"
                            :label="item.name"
                            :value="item">
                    </el-option>
                </el-select>
                <el-select @change="cityChange" v-model="form.city_name" filterable placeholder="请选择城市" :disabled="lock_city">
                    <el-option
                            v-for="item in city_options"
                            :key="item.id"
                            :label="item.name"
                            :value="item">
                    </el-option>
                </el-select>
                <el-select @change="regionChange" v-model="form.region_name" filterable placeholder="请选择区域" :disabled="lock_region">
                    <el-option
                            v-for="item in region_options"
                            :key="item.id"
                            :label="item.name"
                            :value="item">
                    </el-option>
                </el-select>
              </div>
            </el-form-item>

            <el-form-item label="详细地址" prop="detail" >
                <el-input v-model="form.address" placeholder="请输入详细地址" class="max-w460"></el-input>
            </el-form-item>
            
            <el-form-item label="坐标">
                <el-row class="mb16">
                    <el-col :span="24">
                        <el-input v-model="form.coordinate" class="max-w460"></el-input>
                    </el-col>
                </el-row>
                <el-row class="mb16">
                    <el-col :span="24">
                        <Getpoint :form="form" @getMapdata="getMapdataFunc" @chose="choseFunc"></Getpoint>
                    </el-col>
                </el-row>
            </el-form-item>

            <!-- 发布权限设置 -->
            <el-form-item label="发布权限" :label-width="formLabelWidth">
                <el-checkbox-group v-model="form.publishPermissions" @change="handlePermissionChange">
                    <el-checkbox label="inventory">发布库存产品</el-checkbox>
                    <el-checkbox label="import_export">发布进出口</el-checkbox>
                    <el-checkbox label="investment">发布投资项目</el-checkbox>
                    <el-checkbox label="kuajing">跨境云入驻权限</el-checkbox>
                </el-checkbox-group>
                <div class="permission-tips">
                    <el-alert
                        title="发布权限说明"
                        type="info"
                        :closable="false"
                        description="勾选相应的权限后，用户将可以在对应模块发布内容"
                        show-icon>
                    </el-alert>
                </div>
            </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
            <el-button type="primary" @click="editUser" :loading="loading">确 定</el-button>
        </div>
        <Upload v-if="isProductUpload" :config="{ total: 1 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
        </Upload>
    </el-dialog>
</template>

<script>
    import Getpoint from '@/components/map/Getpoint.vue';
    import UserApi from '@/api/user.js';
    import Upload from '@/components/file/Upload';
    export default {
        components: {
            /*图片上传*/
            Upload,
            Getpoint,
        },
        data() {
            return {
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                loading: false,
                dialogVisible: false,
                /* 城市锁 */
                lock_city: true,
                /* 区域锁 */
                lock_region: true,
                province_options: {},
                city_options: {},
                region_options: {},
                password_val: '',
                password_val2: '',
                // 发布权限选项
                publishPermissions: [],
                // 会员到期时间选择器左侧快捷选项
                timePickerOpt: {
                    shortcuts: [{
                        text: '一年',
                        onClick(picker) {
                            const date = new Date()
                            date.setFullYear(date.getFullYear() + 1)
                            picker.$emit('pick', date)
                        }
                    }, {
                        text: '两年',
                        onClick(picker) {
                            const date = new Date()
                            date.setFullYear(date.getFullYear() + 2)
                            picker.$emit('pick', date)
                        }
                    }, {
                        text: '三年',
                        onClick(picker) {
                            const date = new Date()
                            date.setFullYear(date.getFullYear() + 3)
                            picker.$emit('pick', date)
                        }
                    }]
                },
                isProductUpload: false,
                rolearr: [],
            };
        },
        props: ['open_kmd','form', 'gradeList'],
        computed: {
            // 判断是否为经销商角色
            isDealerRole() {
                return this.form.role === 'province' || this.form.role === 'city';
            }
        },
        created() {
            console.log(this.form)
            this.dialogVisible = this.$parent.open_kmd;
            this.getAddressList();
            this.getCustomer();
            this.getRole();
            // 初始化发布权限
            this.initPublishPermissions();
        },
        methods: {
            // 初始化发布权限
          initPublishPermissions() {
    console.log('this.form.publish_permissions', this.form.publish_permissions);
    
    // 统一使用 publishPermissions（不带下划线）作为数据字段
    if (!this.form.publishPermissions) {
        this.$set(this.form, 'publishPermissions', []);
    }
    
    // 如果从数据库获取的是 publish_permissions（带下划线），需要同步到 publishPermissions
    if (this.form.publish_permissions && Array.isArray(this.form.publish_permissions)) {
        this.form.publishPermissions = [...this.form.publish_permissions];
    } else if (typeof this.form.publish_permissions === 'string') {
        try {
            this.form.publishPermissions = JSON.parse(this.form.publish_permissions);
        } catch (e) {
            this.form.publishPermissions = [];
        }
    }
    
    console.log('初始化后的 publishPermissions:', this.form.publishPermissions);
},
            // 权限选择变化处理
            handlePermissionChange(value) {
                console.log('选择的发布权限:', value);
                // 可以在这里添加权限变化的逻辑处理
            },

            // 角色选择变化处理
            handleRoleChange(value) {
                console.log('选择的角色:', value);
                // 如果切换到非经销商角色，清空经销商专属字段
                if (value !== 'province' && value !== 'city') {
                    this.form.saletask = '';
                    this.form.num = '';
                }
                
            
            },

            // 根据角色设置默认权限
            setDefaultPermissions(role) {
                // 根据不同角色设置不同的默认权限
                const defaultPermissions = {
                    'admin': ['inventory', 'import_export', 'investment'], // 管理员拥有所有权限
                    'province': ['inventory', 'import_export', 'investment'], // 省经销商拥有所有权限
                    'city': ['inventory', 'import_export'], // 市经销商拥有库存和进出口权限
                    'user': ['inventory'] // 普通用户只有库存权限
                };

                // 如果当前没有设置权限，则设置默认权限
                if (this.form.publishPermissions.length === 0 && defaultPermissions[role]) {
                    this.form.publishPermissions = [...defaultPermissions[role]];
                }
            },
            
            /*获取经纬度*/
            getMapdataFunc(e) {
                this.form.coordinate = e.data[0].toFixed(6) + ',' + e.data[1].toFixed(6);
            },

            /*选择的地址*/
            choseFunc(e){
                this.form.coordinate = e.location.lat + ',' + e.location.lng;
                this.form.latitude = e.location.lat;
                this.form.longitude = e.location.lng;
                this.form.address = e.address;
            },

            /*打开上传图片*/
            openProductUpload: function (code) {
                this.isProductUpload = true;
                this.code = code
            },

            /*上传商品图片*/
            returnProductImgsFunc(e) {
                if (e != null) {
                    let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
                    let prevent = false;
                    console.log(typeof imgExpt);
                    e.forEach((element) => {
                        let data_array = element.file_path.split(".");
                        let ext = data_array[data_array.length - 1];
                        imgExpt.forEach((e) => {
                            if (e === ext) {
                                prevent = true
                                return false
                            }
                        });
                    });

                    if (!prevent) {
                        this.$message.error("图片类型有误,请选择正确的图片格式");
                        return false;
                    }

                    var avatarUrl = e[0].file_path;
                    this.form.avatarUrl = avatarUrl;
                    this.$set(this.form, "avatarUrl", avatarUrl);
                }

                this.isProductUpload = false;
            },

            getRole(){
                let self = this
                let Params = {}
                UserApi.getRole(Params, true)
                    .then(data => {
                        console.log('data.data', data.data)
                        self.rolearr = data.data
                    })
                    .catch(error => {
                    });
            },

           getCustomer(){
    let self = this;
    let Params = {}
    Params.user_id = self.form.user_id
    console.log(Params)
    UserApi.getCustomerData(Params,true)
        .then(data => {
            console.log(data)
            self.loading = false;
            let formInline = data.data.list;
            if (formInline.province_id > 0){
                self.lock_city = false
                self.form.province_name = formInline.province_name
                self.form.province_id = formInline.province_id
                self.cityList(formInline.province_id)
            }
            if (formInline.city_id > 0){
                self.lock_region = false
                self.form.city_name = formInline.city_name
                self.form.city_id = formInline.city_id
                self.form.region_name = formInline.region_name
                self.form.region_id = formInline.region_id
                self.regionList(formInline.city_id);
            }
            
            // 处理发布权限数据 - 统一使用 publishPermissions
            if (formInline.publish_permissions) {
                try {
                    // 如果是从数据库获取的权限数据，转换为数组并赋值给 publishPermissions
                    if (typeof formInline.publish_permissions === 'string') {
                        self.form.publishPermissions = JSON.parse(formInline.publish_permissions);
                    } else {
                        self.form.publishPermissions = [...formInline.publish_permissions];
                    }
                } catch (e) {
                    console.error('解析发布权限数据失败:', e);
                    self.form.publishPermissions = [];
                }
            } else {
                // 如果没有权限数据，根据角色设置默认权限
                self.setDefaultPermissions(self.form.role);
            }
            
            console.log('最终权限数据:', self.form.publishPermissions);
        })
        .catch(error => {
            self.loading = false;
        });
},
            /* 省份获取 */
            getAddressList(){
                let self = this;
                UserApi.provinceList('',true)
                    .then(data => {
                        self.province_options = data.data.list;
                        console.log(self.province_options)
                    })
                    .catch(error => {
                    });
            },

            /* 市列表 */
            cityList(id){
                let self = this;
                let Params = {}
                Params.province_id = id
                UserApi.city_list(Params,true)
                    .then(data => {
                        self.city_options = data.data.list
                    })
                    .catch(error =>{
                    });
            },

            /* 区列表 */
            regionList(id){
                let self = this;
                let Params = {}
                Params.region_id = id
                UserApi.region_list(Params,true)
                    .then(data => {
                        console.log(data)
                        self.region_options = data.data.list
                    })
                    .catch(error =>{
                    });
            },

            /* 选择省 */
            provinceChange(selVal){
                let self = this
                self.form.province_name = selVal.name
                self.form.province_id = selVal.id
                self.form.city_name = ""
                self.form.city_id = ""
                self.form.region_id = ""
                console.log(self.lock_city)
                self.lock_city = false
                console.log(self.lock_city)
                if (!self.lock_region){
                    self.lock_region = true
                    self.form.region_name = ""
                }
                self.cityList(selVal.id)
            },

            /* 选择市 */
            cityChange(selVal){
                let self = this
                self.form.city_name = selVal.name
                self.form.city_id = selVal.id
                self.form.region_name = ""
                self.form.region_id = ""
                if (self.lock_region){
                    self.lock_region = false
                }
                self.regionList(selVal.id);
            },

            /* 选择区 */
            regionChange(selVal){
                let self = this
                self.form.region_name = selVal.name
                self.form.region_id = selVal.id
                /* 层级太深，需要手动刷新渲染 */
                self.$forceUpdate();
                console.log(self.form.region_name)
            },

           editUser(){
    let self = this;
    self.loading = true;
    let params = self.form;
    
    // 验证经销商专属字段
    if (this.isDealerRole) {
        if (!params.saletask || params.saletask === '') {
            self.$message({
                message: '请输入年销售任务',
                type: 'warning'
            });
            self.loading = false;
            return false;
        }
        
        if (!params.num || params.num === '') {
            self.$message({
                message: '请输入推广数量',
                type: 'warning'
            });
            self.loading = false;
            return false;
        }
        
        // 验证数字有效性
        if (params.saletask < 0) {
            self.$message({
                message: '年销售任务不能为负数',
                type: 'warning'
            });
            self.loading = false;
            return false;
        }
        
        if (params.num < 0) {
            self.$message({
                message: '推广数量不能为负数',
                type: 'warning'
            });
            self.loading = false;
            return false;
        }
    }

    if(self.password_val != ''){
        if(self.password_val2 == ''){
            self.$message({
                message: '请确认新密码',
                type: 'info'
            });
            self.loading = false;
            return false;
        }

        if(self.password_val != self.password_val2){
            self.$message({
                message: '密码不一致',
                type: 'info'
            });
            self.loading = false;
            return false;
        }

        params.password = self.password_val
    }

    // 处理发布权限数据，确保是数组格式 - 统一使用 publishPermissions
    if (params.publishPermissions && Array.isArray(params.publishPermissions)) {
        // 将权限数组转换为字符串存储到 publish_permissions（用于后端）
        params.publish_permissions = JSON.stringify(params.publishPermissions);
    } else {
        params.publish_permissions = '[]';
    }

    console.log('提交的权限数据:', params.publishPermissions);
    console.log('提交到后端的权限数据:', params.publish_permissions);

    UserApi.editAdd(params,true)
        .then(data => {
            self.loading = false;
            if (data.code == 1) {
                self.$message({
                    message: '恭喜你，用户修改成功',
                    type: 'success'
                });
                self.dialogFormVisible(true);
            }
        })
        .catch(error => {
            self.loading = false;
        });
},

            /*关闭弹窗*/
            dialogFormVisible(e) {
                if (e) {
                    this.$emit('closeDialog', {
                        type: 'success',
                        openDialog: false
                    })
                } else {
                    this.$emit('closeDialog', {
                        type: 'error',
                        openDialog: false
                    })
                }
            }
        }
    }
</script>

<style scoped>
    .draggable-list {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
    }

    .draggable-list .wrapper > span {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }

    .draggable-list .item {
        position: relative;
        width: 110px;
        height: 110px;
        margin-top: 10px;
        margin-right: 10px;
        border-radius: 8px;
        overflow: hidden;
        border: 1px solid #dddddd;
    }

    .draggable-list .delete-btn {
        position: absolute;
        top: 0;
        right: 0;
        width: 16px;
        height: 16px;
        background: red;
        line-height: 16px;
        font-size: 16px;
        color: #ffffff;
        display: none;
    }

    .draggable-list .item:hover .delete-btn {
        display: block;
    }

    .draggable-list .item img {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        max-height: 100%;
        max-width: 100%;
    }

    .draggable-list .img-select {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px dashed #dddddd;
        font-size: 30px;
    }

    .draggable-list .img-select i {
        color: #409eff;
    }

    /* 发布权限样式 */
    .permission-tips {
        margin-top: 10px;
        max-width: 460px;
    }

    .el-checkbox-group {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .el-checkbox {
        margin-right: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/views/user/user/dialog/Edit.vue